<template>
    <slider-toggle-field
        :name="valueName"
        label=""
        :value="value"
        @update="valueChanged"
    ></slider-toggle-field>
</template>

<script>
import SliderToggleField from '@/components/SliderToggleField.vue'

export default {
    components: { SliderToggleField },

    props: ['row', 'valueName'],

    computed: {
        value() {
            return Boolean(this.row[this.valueName])
        },
    },

    methods: {
        valueChanged(value) {
            this.$emit('changed', this.row, value)
        },
    },
}
</script>
